import Header from 'components/header'
import Sidebar from 'components/sidebar'
import { usePageAccess } from 'hooks'
import { Outlet } from 'react-router-dom'
import { PAGE_STORE_ORDERS } from 'utils/constants'

const MainLayout = () => {
  const { page } = usePageAccess()

  return (
    <div className="relative h-screen">
      <div className="wrapper flex h-full overflow-hidden">
        {/* Left Section - Sidebar */}
        {page !== PAGE_STORE_ORDERS.id && <Sidebar />}

        {/* Right Section - Header and Main content */}
        <div className="relative flex w-full flex-col">
          <Header />
          <main className="mx-auto h-screen w-full overflow-y-auto bg-[#f7f7f7] p-5 sm:p-8">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}

export default MainLayout
